exports = module.exports = require("../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n    width: 100%;\n}\n\n.m-r-md {\n    margin-right: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/macbookproretina13/Projects/ng5/Movies-Finder/src/app/serie/serie.component.css
// module id = ../../../../../src/app/serie/serie.component.css
// module chunks = main